import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import Loader from '@gr-monorepo/common/public/ui/Loader';
import { Context } from 'stores/pageLoaderContext';

const PageLoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex: 1;
  min-height: 240px;
`;

export const PageLoader = () => {
  const { setLoading } = useContext(Context);

  useEffect(() => {
    setLoading(true);
    return () => {
      setLoading(false);
    };
  }, []);

  return (
    <PageLoaderWrap data-testid="page-loader">
      <Loader size={56} />
    </PageLoaderWrap>
  );
};
